import { render, staticRenderFns } from "./SocialUnitDetail.vue?vue&type=template&id=2c1720e9&scoped=true"
import script from "./SocialUnitDetail.vue?vue&type=script&lang=js"
export * from "./SocialUnitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1720e9",
  null
  
)

export default component.exports